import { render, staticRenderFns } from "./AccountPermissionPreview.vue?vue&type=template&id=44d84d73&scoped=true"
import script from "./AccountPermissionPreview.vue?vue&type=script&lang=js"
export * from "./AccountPermissionPreview.vue?vue&type=script&lang=js"
import style0 from "./AccountPermissionPreview.vue?vue&type=style&index=0&id=44d84d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d84d73",
  null
  
)

export default component.exports